import React from 'react';

import { searchEmojis } from '../../lib/emoji-search/emojiSearch';

import { KEYCHAIN } from '../../contexts/KeyMaster';
import { EmojiList } from './EmojiList';
import SuggestionPortal, { createSuggestionRender } from './SuggestionPortal';

const EmojiSuggestionPortal = ({ clientRect, onClose, ...listProps }) => (
  <SuggestionPortal clientRect={clientRect} onClose={onClose} keychainId={KEYCHAIN.POPOVER__EMOJI_SUGGESTION}>
    <EmojiList {...listProps} />
  </SuggestionPortal>
);

export default function createEmojiSuggestion() {
  return {
    char: ':',
    items: ({ query }) => {
      // Return search results for TipTap to determine whether to show the popup
      return searchEmojis(query, { limit: 5 });
    },

    allowSpaces: false,

    command: ({ editor, range, props }) => {
      // increase range.to by one when the next node is of type "text"
      // and starts with a space character
      const nodeAfter = editor.view.state.selection.$to.nodeAfter;
      const overrideSpace = nodeAfter?.text?.startsWith(' ');

      if (overrideSpace) range.to += 1;

      editor
        .chain()
        .focus()
        .insertContentAt(range, [
          {
            type: 'emoji',
            attrs: {
              id: props.id,
              custom: props.custom,
              image: props.image,
            },
          },
          { type: 'text', text: ' ' },
        ])
        .run();

      // get reference to `window` object from editor element, to support cross-frame JS usage
      editor.view.dom.ownerDocument.defaultView?.getSelection()?.collapseToEnd();
    },

    render: createSuggestionRender(EmojiSuggestionPortal),
  };
}
